function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Mastercard"
}, /*#__PURE__*/React.createElement("path", {
  id: "Left",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.179 12.5995C9.99493 13.5976 8.45902 14.2 6.78069 14.2C3.03582 14.2 0 11.2004 0 7.50005C0 3.79974 3.03582 0.800049 6.78069 0.800049C8.45902 0.800049 9.99493 1.40255 11.179 2.40059C12.363 1.40255 13.8989 0.800049 15.5773 0.800049C19.3221 0.800049 22.358 3.79974 22.358 7.50005C22.358 11.2004 19.3221 14.2 15.5773 14.2C13.8989 14.2 12.363 13.5976 11.179 12.5995Z",
  fill: "#ED0006"
}), /*#__PURE__*/React.createElement("path", {
  id: "Right",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.1797 12.5995C12.6376 11.3706 13.5621 9.542 13.5621 7.50005C13.5621 5.45809 12.6376 3.62949 11.1797 2.40059C12.3637 1.40255 13.8996 0.800049 15.578 0.800049C19.3228 0.800049 22.3587 3.79974 22.3587 7.50005C22.3587 11.2004 19.3228 14.2 15.578 14.2C13.8996 14.2 12.3637 13.5976 11.1797 12.5995Z",
  fill: "#F9A000"
}), /*#__PURE__*/React.createElement("path", {
  id: "Middle",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.1793 12.5995C12.6372 11.3706 13.5616 9.54201 13.5616 7.50007C13.5616 5.45813 12.6372 3.62954 11.1793 2.40063C9.72133 3.62954 8.79688 5.45813 8.79688 7.50007C8.79688 9.54201 9.72133 11.3706 11.1793 12.5995Z",
  fill: "#FF5E00"
}));

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.6f418354.svg";
export { ForwardRef as ReactComponent };